import { useEffect, useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { useConfirmationModal } from "@/context/confirmationModalContext";
import { useTranslation } from "react-i18next";

function useConfirmOnLeave(hasUnsavedChanges: boolean, message: string) {
  const navigator: any = useContext(UNSAFE_NavigationContext).navigator;
  const { showConfirmationModalAsync } = useConfirmationModal();
  const { t } = useTranslation();

  //handles browserReload
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        (e as any).returnValue = ""; // needed for Chrome/Edge/Firefox
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const push = navigator.push;
    const go = navigator.go;

    //handles our navigation
    navigator.push = async (...args: any[]) => {
      const confirm = await showConfirmationModalAsync(t(message));
      if (confirm) {
        push(...args);
      }
    };

    //handles browser backButton
    navigator.go = async (...args: any[]) => {
      const confirm = await showConfirmationModalAsync(t(message));
      if (confirm) {
        go(...args);
      }
    };

    return () => {
      navigator.push = push;
      navigator.go = go;
    };
  }, [navigator, hasUnsavedChanges, message]);
}

export default useConfirmOnLeave;
